import React from 'react'

const IndiGoAir = () => {
  return (
    <div>IndiGoAir</div>
  )
}

export default IndiGoAir